export default __webpack_public_path__ + "static/3-travel-no-nos-4033a7e896f0136325e52e6ca4205fa3.jpg";